export default __webpack_public_path__ + "static/media/ZingCreateActionH1.2be04584.png";